import { SHEET_SECTION, STAGE } from './sheet-sections.js';
import { stageContentIssue } from './stage-content.js';
/** 一次业务确认，仍保留基准尺寸/尺寸偏差两个过渡标记。 */
export const PATTERN_COMPLETION_STAGES = [STAGE.BASE_SIZE_DONE, STAGE.SIZE_SPEC_DONE];
export function completionStages(section, stage, combinedPattern = false) {
    return combinedPattern && section === SHEET_SECTION.PATTERN ? PATTERN_COMPLETION_STAGES : [stage];
}
export function patternCompletion(sheet) {
    const storedCompleted = PATTERN_COMPLETION_STAGES.every(stage => sheet.sectionStages.some(mark => mark.section === SHEET_SECTION.PATTERN && mark.stage === stage && mark.completed));
    const issue = PATTERN_COMPLETION_STAGES.map(stage => stageContentIssue(SHEET_SECTION.PATTERN, stage, sheet)).find(Boolean) ?? null;
    return { storedCompleted, completed: storedCompleted && !issue, issue };
}
//# sourceMappingURL=pattern-completion.js.map